import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import {
    NavBar,
    BreadCumb,
    TimeOut,
    AreYouAgreeModal,
    AppCard,
} from '../../components';
import { ApiClient } from "../../libs/apiClient";
import $ from "jquery";
import config from '../../config';
import download from 'js-file-download';

let apiClient = ApiClient.getInstance();
const apps = [
    {
        appName: "Plug-In vouchers Santander/FMB",
        versionField: "plugInVouchers",
        downloadFile: "plugInVouchers",
        icon: "plugInSant-FMB.png"
    },
    {
        appName: "Plug-In Terminales-Santander/FMB",
        versionField: "plugInTerminal",
        downloadFile: "plugInTerminal",
        icon: "plugInSant-FMB-MIT.png"
    },
    {
        appName: "Plug-In Etiquetas",
        versionField: "plugInTags",
        downloadFile: "plugInTags",
        icon: "PrintTagsLogo.png"
    },
    {
        appName: "App M-Ventas",
        versionField: "mVentasVersion",
        downloadFile: "m-ventas",
        icon: "Mventas.png"
    },
    {
        appName: "App M-Entregas",
        versionField: "mEntregasVersion",
        downloadFile: "m-entregas",
        icon: "Mentregas.png"
    },
    {
        appName: "App M-WMS",
        versionField: "mWHMSVersion",
        downloadFile: "m-wms",
        icon: "Mstock.png"
    }
];

class GlobalConfigView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            settings: {
                nombre: '',
                CP: '',
                RutaEmail: '',
                RutaMonitor: '',
                RutaPdf: '',
                RutaTimbre: '',
                RutaXML: '',
                RutaXMLModulos: '',
                cfdiNoCertificado: '',
                direccion: '',
                regimenFiscal: '',
                rfcNameSuscriptor: '',
                rfcSuscriptor: '',
                rutaATC: '',
                rutaArchivosCfdi: '',
                rutaCadeOriginal: '',
                rutaFTP: '',
                seriesTimbrado: '',
                urlTimbrado: '',
                logoMostrador: '',
                logoDocumentos: '',
                mVentasVersion: '',
                mEntregasVersion: '',
                mWHMSVersion: '',
            },
            editMode: false,
            showAreYouAgreeModal: false,
            user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            plugInVouchers: "",
            plugInTerminal: "",
            plugInTags: "",
        }
    }

    componentDidMount = async () => {
        const { settings } = this.state;
        let Settings = await apiClient.getSettings();

        for (let index = 0; index < Settings.data.length; index++) {
            const element = Settings.data[index];
            settings[element.nombre] = element.valor
        }

        this.setState({
            settings,
        });
        this.handleInputChange = this.handleInputChange.bind(this);
        this.GetAppsVersions();
    }


    GetAppsVersions = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const data = {
            ClientVersion: ''
        }
        const responseApi = await apiClient.ValidateClientVersion(data);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message ?? '' });
            return
        }


        await this.setState({
            mVentasVersion: responseApi.data.mVentas ?? '',
            mEntregasVersion: responseApi.data.mEntregas ?? '',
            mWHMSVersion: responseApi.data.mWMS ?? '',
            plugInVouchers: responseApi.data.plugInVouchers ?? '',
            plugInTerminal: responseApi.data?.plugInTerminal ?? '',
            plugInTags: responseApi.data?.plugInTags ?? '',
        })
    }

    refreshModel = settings => {
        this.setState({
            settings
        })
    };

    ChangeNombre = event => {
        const { settings } = this.state;
        settings.nombre = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeDireccion = event => {
        const { settings } = this.state;
        settings.direccion = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeCP = event => {
        const { settings } = this.state;
        settings.CP = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRfcSuscriptor = event => {
        const { settings } = this.state;
        settings.rfcSuscriptor = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRegimenFiscal = event => {
        const { settings } = this.state;
        settings.regimenFiscal = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeCfdiNoCertificado = event => {
        const { settings } = this.state;
        settings.cfdiNoCertificado = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaArchivosCfdi = event => {
        const { settings } = this.state;
        settings.rutaArchivosCfdi = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaATC = event => {
        const { settings } = this.state;
        settings.rutaATC = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaCadeOriginal = event => {
        const { settings } = this.state;
        settings.rutaCadeOriginal = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaEmail = event => {
        const { settings } = this.state;
        settings.RutaEmail = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaFTP = event => {
        const { settings } = this.state;
        settings.rutaFTP = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaMonitor = event => {
        const { settings } = this.state;
        settings.RutaMonitor = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaPdf = event => {
        const { settings } = this.state;
        settings.RutaPdf = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaTimbre = event => {
        const { settings } = this.state;
        settings.RutaTimbre = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeRutaXML = event => {
        const { settings } = this.state;
        settings.RutaXML = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    ChangeUrlTimbrado = event => {
        const { settings } = this.state;
        settings.urlTimbrado = event.nativeEvent.target.value;
        this.refreshModel(settings);
    };

    AcceptEdit = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
    };

    async handleInputChange(event) {
        // const {notificationReducer: {showAlert}} = this.props;
        let files = event.target.files;
        let filesArr = Array.prototype.slice.call(files);
        let base64 = '';
        filesArr.forEach(function (f) {
            if (!f.type.match("image.*")) return;
            let reader = new FileReader();
            reader.onload = function (e) {
                base64 = e.target.result;
                // document.getElementById("imgBase64").src = base64;
                // this.setState({
                //     image: base64
                // });
            };
            reader.readAsDataURL(f);
        });
    };

    SaveGlobalSettings = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { settings } = this.state;
        let info = [];
        for (const [key, value] of Object.entries(settings)) {
            info.push({
                nombre: key,
                valor: value.toString(),
            })
        }
        const data = {
            setting: info
        }
        let response = await apiClient.UpdateSettings(data);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: response.message });
            await this.setState({
                showAreYouAgreeModal: false,
                editMode: false,
            });
            return;
        }
        showAlert({ type: 'error', message: response.message });
    }

    Send = async () => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });

        $('#areYouAgreeModal').modal('show');
    };

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
        });
    }

    DownloadFile = async (identifier) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            file: identifier
        };
        enableSpinner(true);
        const responsePdf = await apiClient.DownloadFiles(data);
        enableSpinner(false);
        const getFieldName = responsePdf.headers.get('content-disposition');

        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: 'Error al traer PDF', timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }

    }

    render() {
        const {
            settings,
            editMode,
            showAreYouAgreeModal,
            user,
            _user,
        } = this.state;

        const modules = user.U_FMB_Modulos ? JSON.parse(user.U_FMB_Modulos) : null
        let writeAccess = false;
        if (modules.globalConfig) {
            writeAccess = modules.globalConfig.Wr
        }
        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={false} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'CONFIGURACIONES'} url1={'#'} />
                {showAreYouAgreeModal &&
                    <AreYouAgreeModal
                        mensaje={'¿Estas seguro que deseas actualizar los ajustes generales?'}
                        accept={this.SaveGlobalSettings}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }} className="p-3">
                    <div className='row mb-3'>
                        <div className="col-12 col-md-10" >
                            <h2 className="md-display-1"> CONFIGURACIONES GLOBALES </h2>
                        </div>
                        <div className="col-12 col-md-2 text-right" >
                            {!editMode && writeAccess &&
                                <button type="button" className="btn btn-outline-secondary" onClick={this.AcceptEdit}>
                                    <i className="fa fa-pencil-square-o mr-2" aria-hidden="true" />
                                    Editar
                                </button>
                            }
                            {editMode &&
                                <button type="button" className="btn btn-outline-primary" onClick={() => this.Send()}>
                                    <i className="fa fa-floppy-o mr-2" aria-hidden="true" />
                                    Guardar
                                </button>
                            }
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className='col-12 col-md-6'>
                            <h4 className='mb-3'>Datos Fiscales:</h4>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Nombre:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Nombre de la empresa" aria-label="Username" aria-describedby="basic-addon1" value={settings.nombre} onChange={this.ChangeNombre} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Dirección:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Direccion fiscal" aria-label="Username" aria-describedby="basic-addon1" value={settings.direccion} onChange={this.ChangeDireccion} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Código Postal:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="00000" aria-label="Username" aria-describedby="basic-addon1" value={settings.CP} onChange={this.ChangeCP} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">RUT:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="XAXX010101000" aria-label="Username" aria-describedby="basic-addon1" value={settings.rfcSuscriptor} onChange={this.ChangeRfcSuscriptor} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Régimen Fiscal:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="000" aria-label="Username" aria-describedby="basic-addon1" value={settings.regimenFiscal} onChange={this.ChangeRegimenFiscal} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">CFDI No.Certificado:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="00000000000000000000" aria-label="Username" aria-describedby="basic-addon1" value={settings.cfdiNoCertificado} onChange={this.ChangeCfdiNoCertificado} disabled={!editMode ? true : false} />
                            </div>

                            <h4 className='mb-3 mt-5'>Rutas:</h4>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta a archivos CFDI:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.rutaArchivosCfdi} onChange={this.ChangeRutaArchivosCfdi} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta ATC:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.rutaATC} onChange={this.ChangeRutaATC} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta Cade Original:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.rutaCadeOriginal} onChange={this.ChangeRutaCadeOriginal} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta email:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.RutaEmail} onChange={this.ChangeRutaEmail} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta FTP:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.rutaFTP} onChange={this.ChangeRutaFTP} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta monitor:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.RutaMonitor} onChange={this.ChangeRutaMonitor} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta PDF:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.RutaPdf} onChange={this.ChangeRutaPdf} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta Timbre:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.RutaTimbre} onChange={this.ChangeRutaTimbre} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">Ruta XML:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.RutaXML} onChange={this.ChangeRutaXML} disabled={!editMode ? true : false} />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">URL Timbrado:</span>
                                </div>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1" value={settings.urlTimbrado} onChange={this.ChangeUrlTimbrado} disabled={!editMode ? true : false} />
                            </div>

                            {/* <h4 className='mt-5'>Descargar Plugin</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div className="mb-3 p-3">
                                        <a href={require('../../plugin/Install_PrintPlugin.zip')} download="Install_PrintPlugin">
                                            <button type="button" className="btn btn-secondary" >
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </a>
                                    </div>
                                    <div className='pt-3 pb-3' style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/plugin.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                                <div className='row mb-4'>
                                    <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/plugin.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                            </div> */}
                            {/* PLUGIN DE IMPRESIÓN DE VOUCHERS */}
                            {/* <h4 className='mt-5'>{`Descargar plug-In vouchers Santander/FMB.   v${this.state.plugInVouchers ?? ''}`}</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div className="mb-3 p-3">
                                        <label>
                                            <button type="button" className="btn btn-secondary" onClick={() => this.DownloadFile('plugInVouchers')}>
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </label>
                                    </div>
                                    <div className='pt-3 pb-3' style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/plugInSant-FMB.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                            </div> */}

                            {/* PLUGIN COMUNICACIÓN DE TERMINALES DE SANTANDER */}
                            {/* <h4 className='mt-5'>{`Descargar plug-In Terminales-Santander/FMB.   v${this.state.plugInTerminal ?? ''}`}</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div className="mb-3 p-3">
                                        <label>
                                            <button type="button" className="btn btn-secondary" onClick={() => this.DownloadFile('plugInTerminal')}>
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </label>
                                    </div>
                                    <div className='pt-3 pb-3' style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/plugInSant-FMB-MIT.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                            </div> */}

                            {/* PLUGIN IMPRESION DE ETIQUETAS DE CODIGOS DE BARRAS */}
                            {/* <h4 className='mt-5'>{`Descargar plug-In Etiquetas. v${this.state.plugInTags ?? ''}`}</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div>
                                        <label className='pt-3 pl-3'>
                                            <button type="button" className="btn btn-secondary" onClick={() => this.DownloadFile('plugInTags')}>
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </label>
                                    </div>
                                    <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/PrintTagsLogo.png')} alt="Logo" style={{ width: "350px" }}></img>
                                    </div>
                                </div>
                            </div> */}

                            {/* <h4 className='mt-5'>{`Descargar App M-Ventas.   v${this.state.mVentasVersion ?? ''}`}</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div className="mb-3 p-3">
                                        <label>
                                            <button type="button" className="btn btn-secondary" onClick={() => this.DownloadFile('m-ventas')}>
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </label>
                                    </div>
                                    <div className='pt-3 pb-3' style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/Mventas.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                            </div> */}
                            
                            {/* <h4 className='mt-5'>{`Descargar App M-Entregas  v${this.state.mEntregasVersion ?? ''}`}</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div className="mb-3 p-3">
                                        <label >
                                            <button type="button" className="btn btn-secondary" onClick={() => this.DownloadFile('m-entregas')}>
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </label>
                                    </div>
                                    <div className='pt-3 pb-3' style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/Mentregas.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                            </div> */}
                            {/* <h4 className='mt-5'>{`Descargar App M-WMS  v${this.state.mWHMSVersion ?? ''}`}</h4>
                            <div className='mt-3' style={{ border: "solid 1px #ced4da", borderRadius: "8px" }}>
                                <div className='row pl-3'>
                                    <div className="mb-3 p-3">
                                        <label >
                                            <button type="button" className="btn btn-secondary" onClick={() => this.DownloadFile('m-wms')}>
                                                <i className="fa fa-arrow-circle-o-down mr-2" aria-hidden="true" />
                                                Descargar
                                            </button>
                                        </label>
                                    </div>
                                    <div className='pt-3 pb-3' style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <img src={require('../../images/Mstock.png')} alt="Logo" style={{ width: "160px" }}></img>
                                    </div>
                                </div>
                            </div> */}



                        </div>

                        <div className='col-12 col-md-6'>
                            <div className='mb-5'>
                                <h4 className='mb-3'>Logo Mostrador</h4>
                                <div className='border rounded p-3 p-md-4'>
                                    <div className='mb-3'>
                                        <input className="btn btn-secondary w-100"  type="file" id="formFile" onChange={this.handleInputChange} />
                                    </div>
                                    <div className='text-center'>
                                        <img src={require('../../images/logoGlobalInfo.png')} alt="Logo Mostrador" className='img-fluid'  style={{ maxHeight: "280px" }} />
                                        {/* <img src={settings.logoMostrador} name="imgBase64" id="imgBase64" alt="Logs" style={{maxHeight:"280px"}}></img> */}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h4 className='mb-3'>Logo Documentos</h4>
                                <div className='border rounded p-3 p-md-4'>
                                    <div className='mb-3'>
                                        <input className="btn btn-secondary w-100" type="file" id="formFile2" />
                                    </div>
                                    <div className='text-center'>
                                        <img src={require('../../images/logo_EMPRESA.svg')} alt="LogoDocumentos" className='img-fluid' style={{ maxWidth: "100%", maxHeight: "350px" }}/>
                                        {/* <img src={settings.logoDocumentos} name="imgBase64" id="imgBase64" alt="Logs" style={{width:"350px"}}></img> */}
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className='row mb-3'>
                        <p className='col-12 h4 mb-3'> Centro de Descargas</p>
                        <div className='col-12 col-md-6 col-lg-4 mb-3 h-auto'>
                            <div className='border rounded p-3 p-md-4 h-100 d-flex'>
                                <div className='col-3 p-0 align-content-center'>
                                    <img className='w-100' style={{ maxWidth: 160 }} src={require('../../images/plugin.png')} alt="Logo"/>
                                </div>
                                <div className='col-9 d-flex flex-column'>
                                    <p className='font-weight-bold mb-1'> Plugin de Impresión </p>
                                    <div className='mt-auto bd-highlight col-12 col-sm-6 col-md-12 col-lg-12 col-xl-8 p-0' style={{ flex: "none" }}>
                                        <a href={require('../../plugin/Install_PrintPlugin.zip')} download="Install_PrintPlugin">
                                            <button className='btn btn-outline-warning w-100 font-weight-bold'> <i className='fas fa-cloud-download-alt'/> Descargar </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {apps.map((app, index) => 
                            <AppCard
                                app={app.appName}
                                version={this.state[app.versionField]}
                                icon={app.icon}
                                download={() => this.DownloadFile(app.downloadFile)}
                                key={index} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalConfigView);
